import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export function NotFoundPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  // Set proper 404 status for SEO (client-side signal)
  useEffect(() => {
    document.title = '404 - Sidan hittades inte | Klubbspel'
    
    // Send signal that this is a 404 (for prerendering/SSR in future)
    if (typeof window !== 'undefined') {
      // @ts-expect-error - Custom property for SSR/prerendering
      window.__404__ = true
    }
  }, [])

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4">
      <div className="text-center space-y-6 max-w-md">
        <h1 className="text-9xl font-bold text-muted-foreground">404</h1>
        <h2 className="text-3xl font-semibold text-foreground">
          {t('notFound.title', 'Sidan hittades inte')}
        </h2>
        <p className="text-muted-foreground text-lg">
          {t('notFound.description', 'Sidan du letar efter finns inte eller har tagits bort.')}
        </p>
        <div className="flex gap-4 justify-center pt-4">
          <button
            onClick={() => navigate('/')}
            className="px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors font-medium"
          >
            {t('notFound.goHome', 'Gå till startsidan')}
          </button>
          <button
            onClick={() => navigate(-1)}
            className="px-6 py-3 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-colors font-medium"
          >
            {t('notFound.goBack', 'Gå tillbaka')}
          </button>
        </div>
      </div>
    </div>
  )
}
